<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold">manage custom release</small>
      </legend>
      <div></div>

      <div class="shippingfilesLoader">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <i class="fa fa-spinner fa-spin" style="font-sixe: 24px; color: blue"></i>loading files...
      </div>
      <vue-good-table
        :columns="columns"
        :rows="systemShippingfiles"
        :fixed-header="true"
        :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'Action'">

            <button
              v-b-tooltip.hover.bottom="'custom release!'"
              class="btn btn-primary btn-sm btn-rounded"
              @click="viewShippingfile(props.row.id)"
            >
              <i class="fa fa-plus"></i> Add custom release
            </button>
          </span>
        </template>
      </vue-good-table>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "File code",
          field: "file_code",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by file code"
          }
        },
        {
          label: "Customer name",
          field: "customer_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter customer"
          }
        },
        {
          label: "Opened Date",
          field: "opened_date",
          type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy" // outputs Mar 16th 2018
        },
        {
          label: "Bill of landing",
          field: "bill_landing",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by bol"
          }
        },
        {
          label: "Goods description",
          field: "description",
          type: "text"
        },
        {
          label: "Submitted by",
          field: "fullname",
          type: "text"
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true
        }
      ]
    };
  },
  created() {
    this.loadShippingfiles();
  },
  computed: {
    ...mapGetters(["systemShippingfiles"])
  },
  methods: {
    ...mapActions(["loadShippingfiles","viewShippingfile"])
  }
};
</script>


// WEBPACK FOOTER //
// src/customreleases/managecustomrelease.vue